import { labelForMetric } from '@chiroup/core/constants/metricCategories';
import React from 'react';
import Sparkline from './charts/Sparkline';
import { computeTrend, formatTrend, trendArrow, trendColor } from './utils/trend';

type Props = {
  metricKey: string;
  value: number;
  previousValue: number;
  series?: number[];
  onClick?: () => void;
};

// Metrics where "going up" is bad (rejections, errors)
const INVERSE_METRICS = new Set([
  'npi_rejections',
  'enrollment_rejections',
  'format_837_rejections',
  'provider_loop_errors',
  'referring_provider_errors',
  'no_show_cancel_fees_added',
  'users_removed',
]);

const MetricCard: React.FC<Props> = ({ metricKey, value, previousValue, series, onClick }) => {
  const trend = computeTrend(value, previousValue);
  const isInverse = INVERSE_METRICS.has(metricKey);

  return (
    <button
      type="button"
      onClick={onClick}
      className="group flex flex-col items-stretch text-left rounded-lg border border-gray-200 bg-white p-3 hover:border-primary-300 hover:shadow-sm transition focus:outline-none focus:ring-2 focus:ring-primary-500"
    >
      <div className="flex items-baseline justify-between">
        <span className="text-2xl font-semibold text-gray-900 tabular-nums">
          {value.toLocaleString()}
        </span>
        <span className={`text-xs ${trendColor(trend.direction, isInverse)}`}>
          {trendArrow(trend.direction)} {formatTrend(trend)}
        </span>
      </div>
      <div className="text-xs text-gray-600 mt-1 line-clamp-2 min-h-[2rem]">
        {labelForMetric(metricKey)}
      </div>
      <div className="mt-2 -mx-1">
        {series && series.length > 0 ? (
          <Sparkline values={series} width={140} height={24} />
        ) : (
          <div className="h-6" />
        )}
      </div>
    </button>
  );
};

export default MetricCard;
